import { InputStatus } from '@bytel/trilogy-react';
import { InputProps } from '@bytel/trilogy-react/lib/components/input/InputProps';

export function setInputProps({ error }: Readonly<{ error?: string }>): InputProps {
    const props: InputProps = {};

    if (error) {
        props.status = InputStatus.ERROR;
        props.help = error;
    }

    return props;
}
